import React from 'react';
import FaCircle from 'react-icons/lib/fa/circle';
import FaCircleO from 'react-icons/lib/fa/circle-o';
import classNames from 'classnames';
import config from '../../../../config';
import Colors from 'util/Colors';
import _ from 'lodash';

const QualityCheckNavigation = (props) => {
  const {screensData = {}} = props;
  const {qualityCheckItems = []} = screensData;

  if(qualityCheckItems.length <= 1) {
    return null;
  }

  const chunkedQualityChecks = _.chunk(qualityCheckItems, 10);
  return <div className="top30">
    {chunkedQualityChecks.map((items, outerIndex) => {
      return <div key={outerIndex} style={{}}>
        {items.map((item, index) => {
          const itemChecked = (screensData.currentQualityCheckRecord._id == item._id && item.checkedStatus && chunkedQualityChecks.length - 1 == outerIndex && items.length - 1 == index) ||
            (screensData.currentQualityCheckRecord._id == item._id && !item.checkedStatus) ||
            (item.checkedStatus && screensData.currentQualityCheckRecord._id !== item._id);
          let notAllowed = false;

          if(item.qualityCheckType == config.deterministicQualityCheckTypes.Base && !item.firstBaseQualityCheck) {
            notAllowed = true;
          }

          const displayItemIndex = qualityCheckItems.findIndex(qualityCheckItem => item._id == qualityCheckItem._id);

          let itemColor = Colors.lightBlue;

          if (screensData.currentQualityCheckRecord._id == item._id) {
            itemColor = Colors.lightBlue;
          }

          if (item.checkedStatus == 'failed') {
            itemColor = Colors.red;
          }

          if (item.checkedStatus == 'passed') {
            itemColor = Colors.green;
          }

          return <span key={index}   data-testid={`quality-check-navigation-button-${index}`} style={{marginBottom: 2,}}>
                            <span
                              className={classNames('quality-check-navigation-button',
                                {
                                  'not-allowed':itemChecked && notAllowed,
                                  'cursor-pointer': itemChecked
                                })}
                              onClick={() => {
                                if (config.getEnvironmentName() == 'local' || (itemChecked && !notAllowed)) {
                                  let dataToUpdate = {
                                    currentQualityCheckRecord: qualityCheckItems[displayItemIndex]
                                  };

                                  if(screensData.currentQualityCheckRecord.currentStep) {
                                    const foundItemIndex = qualityCheckItems.findIndex((qualityCheckItem) => {
                                      return screensData.currentQualityCheckRecord._id == qualityCheckItem._id;
                                    });
                                    dataToUpdate.qualityCheckItems = [...qualityCheckItems.slice(0, foundItemIndex),
                                      {...screensData.currentQualityCheckRecord, currentStep:''},
                                      ...qualityCheckItems.slice(foundItemIndex + 1)];
                                  }

                                  props.setScreensData(dataToUpdate);
                                }
                              }}

                              style={{marginRight: 6}}>
                                {itemChecked ?
                                  <FaCircle style={{'color': itemColor, fontSize: 19}}/> :
                                  <FaCircleO style={{'color': itemColor, fontSize: 19}}/>
                                }

                            </span>

                        </span>;
        })}
      </div>;
    })}
  </div>;
};

export default QualityCheckNavigation;